/**
 * Returns a list with stopwords for the German passive voice assessment.
 * @returns {Array} The list with stopwords.
 */
export default [
	":",
	"aber",
	"als",
	"bevor",
	"bis",
	"da",
	"damit",
	"daß",
	"dass",
	"denn",
	"doch",
	"ehe",
	"falls",
	"gleichwohl",
	"indem",
	"indes",
	"indessen",
	"insofern",
	"insoweit",
	"nachdem",
	"nun",
	"ob",
	"obgleich",
	"obschon",
	"obwohl",
	"obzwar",
	"oder",
	"seitdem",
	"sobald",
	"sodass",
	"sofern",
	"solange",
	"sondern",
	"sooft",
	"soviel",
	"soweit",
	"sowie",
	"trotz",
	"und",
	"ungeachtet",
	"waehrend",
	"während",
	"weil",
	"welche",
	"welchem",
	"welchen",
	"welcher",
	"welches",
	"wem",
	"wen",
	"wenn",
	"wenngleich",
	"wennschon",
	"wer",
	"wes",
	"wessen",
	"wie",
	"wiewohl",
	"wohingegen",
	"zumal",
];

